<template>
  <v-data-table
    :headers="headers"
    :items="canSizes"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="CanSize-button-new"
          @click="$router.push({
            name: 'processing-EditCanSize'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditCanSize',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCanSize',
  module: 'CanSize',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('canSizes', ['canSizes']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: 'Size',
          value: 'size',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_canSizes();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('canSizes', ['LOAD_canSizes', 'DELETE_canSize']),
    /** Delete CanSize from the collection
     */
    async remove(CanSize) {
      this.isLoading = true;
      await this.DELETE_CanSize(CanSize);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# CanSize example

'''js
<CanSize />
'''
</docs>
